import lazyPage from 'packages/core/hoc/lazyPage'

export default () => ({
  path: '/contacts',
  component: lazyPage(() => import('app/view/Contacts')),
  exact: true,
})
